export default __webpack_public_path__ + "static/media/diptool.93135297.png";